import React, { FC } from 'react';

export const TeacherStudentPage: FC = ({}) => {
  return (
    <>
      <p>TeacherStudentPage</p>
    </>
  );
};
